import React from 'react';
import AuthForm from './auth-form.jsx';
import AuthShell from './auth-shell.jsx';

function AuthCoverBgResetPassword() {
	return <AuthShell variant="cover-bg"><AuthForm variant="cover-bg" mode="reset-password" /></AuthShell>;
}

export default AuthCoverBgResetPassword;
